class Suggestion {
    constructor(title, action, predefinedResponse = null, predefinedPrompt = null, functionName = null, suggestions = [], filePath = '', content = null) {
        this.title = title;
        this.action = action;
        this.predefinedResponse = predefinedResponse;
        this.predefinedPrompt = predefinedPrompt;
        this.functionName = functionName;
        this.content = content;
        this.suggestions = suggestions.map(s => new Suggestion(s.title, s.action, s.predefined_response, s.predefined_prompt, s.function_name, s.suggestions, s.file_path, s.content));
        this.filePath = filePath;
    }
}

export class AssistantConfig {
    constructor(id, type, profile_picture, welcome_message, loading_messages, name, last_name, suggestions) {
        this.id = id;
        this.type = type;
        this.profilePicture = profile_picture;
        this.welcomeMessage = welcome_message;
        this.loadingMessages = loading_messages;
        this.name = name;
        this.lastName = last_name;
        if (suggestions) {
            this.suggestions = suggestions.map(s => new Suggestion(s.title, s.action, s.predefined_response, s.predefined_prompt, s.function_name, s.suggestions, s.file_path, s.content));    
        }
        
    }

    static fromJSON(json) {
        return new AssistantConfig(
            json._id,
            json.type,
            json.profile_picture,
            json.welcome_message,
            json.loading_messages,
            json.name,
            json.last_name,
            json.suggestions
        );
    }
}
